/**
 * Tennis live-court colour presets (presentation only — not match state).
 * Cycle order used by the scorecard colour control.
 */
export const TENNIS_COURT_COLOURS = Object.freeze(["grass", "hard", "clay"]);

export const TENNIS_COURT_COLOUR_DEFAULT = "grass";

export const TENNIS_COURT_COLOUR_LABELS = Object.freeze({
  clay: "Clay",
  grass: "Grass",
  hard: "Hard",
});

/** Swatch chips for the toolbar control. */
export const TENNIS_COURT_COLOUR_SWATCHES = Object.freeze({
  clay: "#b8704f",
  grass: "#4f9a5c",
  hard: "#3a5f88",
});

export function normalizeTennisCourtColour(value) {
  if (TENNIS_COURT_COLOURS.includes(value)) return value;
  return TENNIS_COURT_COLOUR_DEFAULT;
}

export function nextTennisCourtColour(current) {
  const cur = normalizeTennisCourtColour(current);
  const i = TENNIS_COURT_COLOURS.indexOf(cur);
  return TENNIS_COURT_COLOURS[(i + 1) % TENNIS_COURT_COLOURS.length];
}
